var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useContext } from 'react';
import { Box } from "@mui/material";
import { ButtonComponent } from "../shared/ButtonComponent/ButtonComponent";
import { ApplicationContext } from '../ApplicationProvider';
import { useMsal } from '@azure/msal-react';
import { saveContact } from '../../services/ContactService';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var DeleteContactModal = function (_ref) {
    var contactId = _ref.contactId, handleDeletion = _ref.handleDeletion;
    var setShowDialog = useContext(ApplicationContext).setShowDialog;
    var azureADPCA = useMsal().instance;
    var deleteData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _azureADPCA$getActive, _azureADPCA$getActive2, userEmail, tokenClaims, userGUID, _azureADPCA$getActive3, _azureADPCA$getActive4, deleteContact, dataToDelete, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    userEmail = ((_azureADPCA$getActive = azureADPCA.getActiveAccount()) === null || _azureADPCA$getActive === void 0 ? void 0 : _azureADPCA$getActive.username) || 'test@test.com';
                    if ((_azureADPCA$getActive2 = azureADPCA.getActiveAccount()) !== null && _azureADPCA$getActive2 !== void 0 && _azureADPCA$getActive2.idTokenClaims) {
                        tokenClaims = (_azureADPCA$getActive3 = azureADPCA.getActiveAccount()) === null || _azureADPCA$getActive3 === void 0 ? void 0 : _azureADPCA$getActive3.idTokenClaims;
                        if (tokenClaims && tokenClaims.hasOwnProperty('email')) {
                            userEmail = tokenClaims['email'];
                        }
                        userGUID = (_azureADPCA$getActive4 = azureADPCA.getActiveAccount()) === null || _azureADPCA$getActive4 === void 0 ? void 0 : _azureADPCA$getActive4.localAccountId;
                    }
                    deleteContact = { AzureB2CUserEmail: userEmail, AzureB2CUserGuid: userGUID, ContactInfoId: contactId };
                    dataToDelete = { Contact: deleteContact, SaveOperationType: 3 };
                    return [4 /*yield*/, saveContact(dataToDelete)];
                case 1:
                    result = _a.sent();
                    handleDeletion(true);
                    setShowDialog(false);
                    return [2 /*return*/];
            }
        });
    }); };
    return /*#__PURE__*/ _jsxs(Box, { display: "flex", flexDirection: "column", children: [/*#__PURE__*/ _jsx("label", { htmlFor: "SavedItemTitle", className: 'small-para-semibold ml-2', children: "Are you sure you want to delete the contact?" }), /*#__PURE__*/ _jsx("br", {}), /*#__PURE__*/ _jsxs("div", { className: "row m-0", children: [/*#__PURE__*/ _jsx(ButtonComponent, { buttonType: 'primary', buttonText: 'Yes, Delete', buttonCss: { margin: 0 }, click: function () { return deleteData(); } }), "\xA0 \xA0", /*#__PURE__*/ _jsx(ButtonComponent, { buttonType: 'secondary', buttonText: 'Cancel', buttonCss: { margin: 0 }, click: function () { return setShowDialog(false); } })] })] });
};
